export { default } from './PartnersPrograms';
